export const AE_LOGO_URL =
    "https://customer-assets.emergentagent.com/job_7f285dda-5817-49f1-919b-fd77ae29fda1/artifacts/b07uljuy_Ae%20lofo%202026%20orange%20button.png";

export const AE_KEY_VISUAL =
    "https://customer-assets.emergentagent.com/job_7f285dda-5817-49f1-919b-fd77ae29fda1/artifacts/tdwtmxvg_Ae%20Co%20Profile%202026%20copy.jpg";

export const NAV_LINKS = [
    { label: "Work", href: "#work" },
    { label: "Services", href: "#services" },
    { label: "AI", href: "#ai" },
    { label: "Process", href: "#process" },
    { label: "Brands", href: "#brands" },
    { label: "Contact", href: "#contact" },
];

export const SERVICES = [
    {
        id: "strategy",
        title: "AI Strategy & Planning",
        desc: "Research, roadmaps, audience insights and strategic direction powered by data and AI.",
        icon: "Compass",
    },
    {
        id: "creative",
        title: "Creative & Digital Ads",
        desc: "Brand campaigns, content, social media, performance ads and full-funnel media buying.",
        icon: "Megaphone",
    },
    {
        id: "websites",
        title: "Websites & Apps",
        desc: "Corporate websites, landing pages, dashboards and custom software builds.",
        icon: "MonitorSmartphone",
    },
    {
        id: "activations",
        title: "Interactive Activations",
        desc: "Digitally enhanced events, lead capture, engagement and experiential builds.",
        icon: "Sparkles",
    },
    {
        id: "analytics",
        title: "Analytics & Reporting",
        desc: "Dashboards, insights, ROI measurement, test-and-learn loops and optimization.",
        icon: "BarChart3",
    },
    {
        id: "beyond",
        title: "Beyond Advertising",
        desc: "Solutions that connect creative, technology, data and real-world interaction.",
        icon: "Star",
    },
];

export const AI_PILLARS = [
    {
        title: "AI in Planning",
        desc: "Faster audience modeling, market intelligence, briefs and predictive media planning.",
        icon: "Brain",
    },
    {
        title: "AI in Creative",
        desc: "Concept exploration, visual generation, copy variations and rapid A/B testing.",
        icon: "Wand2",
    },
    {
        title: "AI in Advertising",
        desc: "Automated bidding, dynamic creative optimization and channel-level recommendations.",
        icon: "TrendingUp",
    },
    {
        title: "AI in Analytics",
        desc: "Real-time dashboards, anomaly detection, attribution and learnings at scale.",
        icon: "LineChart",
    },
    {
        title: "AI in Technology",
        desc: "AI-augmented software builds, smart activations, and connected brand systems.",
        icon: "Cpu",
    },
];

export const FEATURED_WORK = [
    {
        slug: "bic-flex-because-i-can",
        title: "Because I Can",
        client: "BIC Shavers (Flex)",
        category: "Integrated Brand Campaign",
        tag: "FMCG",
        featured: true,
        image: "https://customer-assets.emergentagent.com/job_amplify-everything/artifacts/7cmk9fpw_BIC%20shavers.png",
        summary:
            "A bold, lifestyle-led campaign positioning BIC Flex razors as the everyday confidence booster for the modern man — built around the rallying line 'Why Flex? Because I Can.'",
        objective:
            "Reframe BIC Flex from a value razor to an aspirational grooming choice, and grow share in the premium 3-blade and 5-blade segments.",
        approach: [
            "Audience deep-dive into 18–35 male grooming behavior across PH urban centers.",
            "Hero key visual built on four moments of confidence: work, sport, social, intimacy.",
            "AI-assisted creative variants for each moment, optimized per platform.",
            "Performance buys across Meta, TikTok, YouTube Shorts + retail point-of-sale.",
        ],
        results: [
            { label: "Brand consideration lift", value: "+34%" },
            { label: "Avg CPA reduction", value: "−28%" },
            { label: "Creative variants shipped", value: "42" },
        ],
        services: ["Strategy", "Creative", "AI", "Performance Ads", "Retail Activation"],
    },
    {
        slug: "bic-best-lighter-choice",
        title: "Best Lighter Choice",
        client: "BIC Lighters",
        category: "Brand Platform & Performance",
        tag: "FMCG",
        featured: true,
        image: "https://customer-assets.emergentagent.com/job_amplify-everything/artifacts/a9qbuvar_BIC%20Lighters.png",
        summary:
            "A category-defining campaign that anchored BIC as the dependable flame for every Filipino moment — from stove to grill, party to bonfire. Tagline: 'No Flame Like a BIC Flame.'",
        objective:
            "Defend leadership against low-cost imports and reinforce BIC's safety + reliability cues across mass-market and modern trade.",
        approach: [
            "Built a 'use occasions' brand platform — Stove, Grill, Party, Bonfire — that scales across formats.",
            "Hero visual + 8 occasion-led cutdowns produced with AI-assisted creative iteration.",
            "Modern trade and sari-sari point-of-sale kit + digital out-of-home.",
            "Always-on performance layer with dynamic creative optimization.",
        ],
        results: [
            { label: "Aided awareness", value: "+22%" },
            { label: "Modern-trade sell-through", value: "+18%" },
            { label: "ROAS", value: "4.6×" },
        ],
        services: ["Brand Platform", "Creative", "AI", "Digital Ads", "Trade Marketing"],
    },
    {
        slug: "birch-tree-milk",
        title: "kaBIRCH TEAM",
        client: "Birch Tree Milk",
        category: "Brand Campaign",
        tag: "FMCG",
        image: "/work/birch-tree-milk.jpg",
    },
    {
        slug: "birch-tree-everybody",
        title: "It's Everybody's Milk!",
        client: "Birch Tree Milk",
        category: "Product Campaign",
        tag: "FMCG",
        image: "/work/birch-tree-everybody.jpg",
    },
    {
        slug: "555-sardines",
        title: "Una sa Nag-iisang Sarap",
        client: "555 Sardines",
        category: "#CertiFRIED Campaign",
        tag: "FMCG",
        image: "/work/555-sardines.jpg",
    },
    {
        slug: "555-certifried",
        title: "#CertiFRIED Masarap",
        client: "555 Sardines",
        category: "Social Campaign",
        tag: "FMCG",
        image: "/work/555-certifried.jpg",
    },
    {
        slug: "555-sardance",
        title: "555 SarDance Challenge",
        client: "555 Sardines",
        category: "Social Challenge",
        tag: "FMCG",
        image: "/work/555-sardance.jpg",
    },
    {
        slug: "555-pritography",
        title: "Pritography Challenge",
        client: "555 Sardines",
        category: "UGC Campaign",
        tag: "FMCG",
        image: "/work/555-pritography.jpg",
    },
    {
        slug: "555-date-ideas",
        title: "Fried Sardines Date Ideas",
        client: "555 Sardines",
        category: "Branded Content",
        tag: "FMCG",
        image: "/work/555-date-ideas.jpg",
    },
    {
        slug: "555-bento",
        title: "Sauce-Sarap Bento",
        client: "555 Sardines",
        category: "Recipe Content",
        tag: "FMCG",
        image: "/work/555-bento.jpg",
    },
    {
        slug: "555-sauce-sarap",
        title: "Sauce-Sarap, Lasa Malaman",
        client: "555 Sardines",
        category: "Brand Platform",
        tag: "FMCG",
        image: "/work/555-sauce-sarap.jpg",
    },
    {
        slug: "555-malaman",
        title: "Ang Lasa Malaman",
        client: "555 Sardines",
        category: "Product Campaign",
        tag: "FMCG",
        image: "/work/555-malaman.jpg",
    },
    {
        slug: "555-halloween",
        title: "Happy Halloween",
        client: "555 Sardines",
        category: "Seasonal Campaign",
        tag: "FMCG",
        image: "/work/555-halloween.jpg",
    },
    {
        slug: "555-pasko",
        title: "Maligayang Pasko",
        client: "555 Sardines",
        category: "Seasonal Campaign",
        tag: "FMCG",
        image: "/work/555-pasko.jpg",
    },
    {
        slug: "nutririte",
        title: "Start Your Day Right",
        client: "NutriRite",
        category: "Brand Endorsement",
        tag: "FMCG",
        image: "/work/nutririte.jpg",
    },
    {
        slug: "nutririte-365",
        title: "365 Days of Nutrition",
        client: "NutriRite",
        category: "Product Campaign",
        tag: "FMCG",
        image: "/work/nutririte-365.jpg",
    },
    {
        slug: "nutririte-mix",
        title: "my NutriRite MIX",
        client: "NutriRite",
        category: "Packaging",
        tag: "FMCG",
        image: "/work/nutririte-mix.jpg",
    },
    {
        slug: "caferite-milano",
        title: "Every Sip Feels Like Milan",
        client: "CafeRite — Café Milano",
        category: "Product Campaign",
        tag: "FMCG",
        image: "/work/caferite-milano.jpg",
    },
    {
        slug: "caferite-crema-italia",
        title: "Crema Italia",
        client: "CafeRite — Café Milano",
        category: "Packaging",
        tag: "FMCG",
        image: "/work/caferite-crema-italia.jpg",
    },
    {
        slug: "caferite-sari-sari",
        title: "Sari-Sari Stories",
        client: "CafeRite Coffee",
        category: "Branded Content",
        tag: "FMCG",
        image: "/work/caferite-sari-sari.jpg",
    },
    {
        slug: "caferite-creations",
        title: "CafeRite Creations",
        client: "CafeRite Coffee",
        category: "Packaging",
        tag: "FMCG",
        image: "/work/caferite-creations.jpg",
    },
    {
        slug: "caferite-halloween",
        title: "Halloween Trick or Treat",
        client: "CafeRite — Café Milano",
        category: "Seasonal Campaign",
        tag: "FMCG",
        image: "/work/caferite-halloween.jpg",
    },
    {
        slug: "caferite-gift-pack",
        title: "Win a Café Milano Gift Pack",
        client: "CafeRite — Café Milano",
        category: "Promo Campaign",
        tag: "FMCG",
        image: "/work/caferite-gift-pack.jpg",
    },
    {
        slug: "caferite-bagong-silang",
        title: "Now in Bagong Silang, QC",
        client: "CafeRite — Café Milano",
        category: "Retail Activation",
        tag: "FMCG",
        image: "/work/caferite-bagong-silang.jpg",
    },
    {
        slug: "hillway",
        title: "TEAKman Mo Na!",
        client: "Hillway Bubble Tea",
        category: "Product Launch",
        tag: "FMCG",
        image: "/work/hillway.jpg",
    },
    {
        slug: "hillway-real-bubbles",
        title: "Real Bubbles",
        client: "Hillway Bubble Tea",
        category: "Product Campaign",
        tag: "FMCG",
        image: "/work/hillway-real-bubbles.jpg",
    },
    {
        slug: "hillway-sachet",
        title: "Bubble Tea In A Sachet",
        client: "Hillway Bubble Tea",
        category: "Packaging",
        tag: "FMCG",
        image: "/work/hillway-sachet.jpg",
    },
    {
        slug: "hillway-flavors",
        title: "Hillway Flavors",
        client: "Hillway Bubble Tea",
        category: "Packaging",
        tag: "FMCG",
        image: "/work/hillway-flavors.jpg",
    },
    {
        slug: "smdc-fame",
        title: "SMDC FAME",
        client: "SM Development Corp.",
        category: "Website & Digital",
        tag: "Real Estate",
        image: "/work/smdc-fame.jpg",
    },
    {
        slug: "smdc-microsites",
        title: "Property Microsites",
        client: "SM Development Corp.",
        category: "Website & Digital",
        tag: "Real Estate",
        image: "/work/smdc-microsites.jpg",
    },
    {
        slug: "the-estate-makati",
        title: "The Estate Makati",
        client: "The Estate Makati",
        category: "Corporate Website",
        tag: "Real Estate",
        image: "/work/the-estate-makati.jpg",
    },
    {
        slug: "letstay",
        title: "Let's Manage Your Property",
        client: "Letstay Inc.",
        category: "Website & Digital",
        tag: "Real Estate",
        image: "/work/letstay.jpg",
    },
    {
        slug: "greenmist",
        title: "Greenmist Property Mgmt",
        client: "Greenmist",
        category: "Corporate Website",
        tag: "Real Estate",
        image: "/work/greenmist.jpg",
    },
    {
        slug: "one-draft",
        title: "Design & Construction",
        client: "One Draft",
        category: "Corporate Website",
        tag: "Real Estate",
        image: "/work/one-draft.jpg",
    },
    {
        slug: "arco-group",
        title: "Arco Group",
        client: "Arco Group",
        category: "Corporate Website",
        tag: "Real Estate",
        image: "/work/arco-group.jpg",
    },
    {
        slug: "st-lukes",
        title: "Mayo Clinic Care Network",
        client: "St. Luke's Medical Center",
        category: "Corporate Website",
        tag: "Healthcare",
        image: "/work/st-lukes.jpg",
    },
    {
        slug: "carrier",
        title: "Carrier Philippines",
        client: "Carrier Philippines",
        category: "Website & Digital",
        tag: "HVAC",
        image: "/work/carrier.jpg",
    },
    {
        slug: "condura",
        title: "Iba ang Pinoy",
        client: "Condura",
        category: "Brand Platform",
        tag: "HVAC",
        image: "/work/condura.jpg",
    },
    {
        slug: "condura-ac",
        title: "Condura Air Conditioning",
        client: "Condura",
        category: "Website & Digital",
        tag: "HVAC",
        image: "/work/condura-ac.jpg",
    },
    {
        slug: "concepcion",
        title: "A Vision of the Future",
        client: "Concepcion Industrial",
        category: "Corporate Website",
        tag: "Industrial",
        image: "/work/concepcion.jpg",
    },
    {
        slug: "alstra-web",
        title: "Building & Industrial Solutions",
        client: "Alstra",
        category: "Corporate Website",
        tag: "Industrial",
        image: "/work/alstra-web.jpg",
    },
    {
        slug: "next-century",
        title: "Build the Future",
        client: "Next Century Building Systems",
        category: "Corporate Website",
        tag: "Industrial",
        image: "/work/next-century.jpg",
    },
    {
        slug: "centralworld",
        title: "Centralworld Enterprises",
        client: "Centralworld",
        category: "Corporate Website",
        tag: "Business",
        image: "/work/centralworld.jpg",
    },
    {
        slug: "dmv",
        title: "Documentation Services",
        client: "DMV Documentation",
        category: "Corporate Website",
        tag: "Business",
        image: "/work/dmv.jpg",
    },
    {
        slug: "citymart",
        title: "CityMart Online Store",
        client: "CityMart",
        category: "E-Commerce",
        tag: "Retail",
        image: "/work/citymart.jpg",
    },
    {
        slug: "peeva",
        title: "Peeva Restaurant",
        client: "Peeva",
        category: "Website & Digital",
        tag: "F&B",
        image: "/work/peeva.jpg",
    },
    {
        slug: "digital-2wist",
        title: "Digital 2wist",
        client: "Digital 2wist",
        category: "Website & Digital",
        tag: "Digital",
        image: "/work/digital-2wist.jpg",
    },
    {
        slug: "deuts",
        title: "Deuts Web Design",
        client: "Deuts",
        category: "Website & Digital",
        tag: "Digital",
        image: "/work/deuts.jpg",
    },
    {
        slug: "sopi-beats",
        title: "Sopi Beats",
        client: "Sopi Beats",
        category: "Website & Digital",
        tag: "Music",
        image: "/work/sopi-beats.jpg",
    },
    {
        slug: "smdc-live-ar",
        title: "On-Ground Live AR",
        client: "SM Development Corp.",
        category: "Interactive Activation",
        tag: "Activation",
        image: "/work/smdc-live-ar.jpg",
    },
    {
        slug: "smdc-pro",
        title: "SMDC PRO WebApp",
        client: "SM Development Corp.",
        category: "Web App",
        tag: "Real Estate",
        image: "/work/smdc-pro.jpg",
    },
    {
        slug: "big-crunch",
        title: "Interactive Bus Stop",
        client: "Big Crunch",
        category: "Experiential Activation",
        tag: "Activation",
        image: "/work/big-crunch.jpg",
    },
    {
        slug: "ccac-ar",
        title: "Augmented Reality Showroom",
        client: "Concepcion-Carrier",
        category: "AR Experience",
        tag: "Activation",
        image: "/work/ccac-ar.jpg",
    },
    {
        slug: "ccac-interactive",
        title: "Interactive Display",
        client: "Concepcion-Carrier",
        category: "Interactive Display",
        tag: "Activation",
        image: "/work/ccac-interactive.jpg",
    },
    {
        slug: "ccac-buyers-guide",
        title: "Buyer's Guide Display",
        client: "Concepcion-Carrier",
        category: "Interactive Display",
        tag: "Activation",
        image: "/work/ccac-buyers-guide.jpg",
    },
    {
        slug: "alstra-k360",
        title: "Alstra K360 App",
        client: "Alstra",
        category: "Mobile App",
        tag: "App",
        image: "/work/alstra-k360.jpg",
    },
    {
        slug: "alstra-photo-booth",
        title: "Alstra Photo Booth",
        client: "Alstra",
        category: "Experiential Activation",
        tag: "Activation",
        image: "/work/alstra-photo-booth.jpg",
    },
    {
        slug: "nutririte-planner",
        title: "Nutrition Planner",
        client: "NutriRite",
        category: "Mobile App",
        tag: "App",
        image: "/work/nutririte-planner.jpg",
    },
    {
        slug: "foresee",
        title: "Foresee App",
        client: "Foresee",
        category: "Mobile App",
        tag: "App",
        image: "/work/foresee.jpg",
    },
    {
        slug: "benby",
        title: "Benby Event Sign-In",
        client: "Benby",
        category: "Event Activation",
        tag: "Activation",
        image: "/work/benby.jpg",
    },
];

export const BRAND_EXPERIENCE = [
    {
        industry: "Real Estate",
        icon: "Building2",
        clients: [
            "SM Development Corp.",
            "Greenmist Property Management",
            "Primehomes",
            "ArcoGroup",
            "Nuvoland",
            "One Draft Design & Construction",
            "LetStay",
        ],
    },
    {
        industry: "Healthcare",
        icon: "HeartPulse",
        clients: ["St. Luke's Medical Center", "Asian Eye Institute", "Bioessence"],
    },
    {
        industry: "HVAC",
        icon: "Fan",
        clients: ["Concepcion-Carrier", "Condura", "Alstra"],
    },
    {
        industry: "FMCG",
        icon: "ShoppingBasket",
        clients: [
            "NutriAsia",
            "Datu Puti",
            "Golden Fiesta",
            "Coke",
            "Century Pacific",
            "555 Sardines",
            "Birch Tree Milk",
            "NutriRite",
            "CafeRite Coffee",
            "Benby",
        ],
    },
    {
        industry: "Renewable Energy",
        icon: "Leaf",
        clients: ["All Power Labs"],
    },
];

export const PROCESS_STEPS = [
    {
        num: "01",
        title: "Discover",
        desc: "Deep dive into brand, market, audience and category truths.",
    },
    {
        num: "02",
        title: "Strategize",
        desc: "AI-assisted planning, positioning and channel architecture.",
    },
    {
        num: "03",
        title: "Create",
        desc: "Concepts, creative, content and product experiences.",
    },
    {
        num: "04",
        title: "Launch",
        desc: "Campaigns go live across paid, owned, earned and real-world.",
    },
    {
        num: "05",
        title: "Measure & Amplify",
        desc: "Real-time analytics, learnings and continuous optimization.",
    },
];
